// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"b0b8cf0b","453":"6097658f"}[chunkId] + ".chunk.js";
};